var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ModifyComplaintModal.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4b437b4e\",\"hasScoped\":false}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ModifyComplaintModal.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/teacher/modal/ModifyComplaintModal.vue
// module id = 1541
// module chunks = 8